import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useStyle } from "../context/StyleContext";

const WelcomeScreen = () => {
  const navigate = useNavigate();
  const styles = useStyle();
  const videoRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const hasVisited = localStorage.getItem("hasVisitedWelcomeScreen");
    if (!hasVisited) {
      localStorage.setItem("hasVisitedWelcomeScreen", "true");
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("paymentToken");

    if (token) {
      navigate("/photo-capture");
    }

    // Minimize loading delay
    const loadDelay = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(loadDelay);
  }, [navigate]);

  const handleStartSession = () => {
    const video = videoRef.current;
    if (video) {
      video.play();
      video.onended = () => {
        if (styles.isPaymentOn) navigate("/payment");
        else navigate("/photo-capture");
      };
    }
  };

  if (!styles) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="border-8 border-t-8 border-t-blue-500 border-gray-200 rounded-full w-24 h-24 animate-spin"></div>
      </div>
    );
  }

  return isLoading ? (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      style={{ backgroundColor: styles.backgroundColor }}
    >
      {/* <div className="border-8 border-t-8 border-t-blue-500 border-gray-200 rounded-full w-24 h-24 animate-spin"></div> */}
    </div>
  ) : (
    <div
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden z-50"
      onClick={handleStartSession}
    >
      <video
        ref={videoRef}
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
        muted
        preload="auto"
        style={{ aspectRatio: "16/9" }}
      >
        <source src={styles.loadingAnimation} type="video/webm" />
      </video>

      <div className="relative z-20 text-center mt-96">
        <motion.h1
          className="text-7xl sm:text-6xl w-screen font-extrabold mb-8 p-12 mt-96"
          style={{ color: styles.textColor, fontFamily: styles.fontFamily }}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Press Anywhere on screen to get started
          <div className="text-xl my-5">
            <span className="text-2xl font-bold">Privacy/Policy: </span>we do
            not save or share your photos or your payment information.
            <br />
            Press the icon on top right of screen to view the complete terms and
            conditions.
          </div>
        </motion.h1>
      </div>
    </div>
  );
};

export default WelcomeScreen;
